import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify'
import { UpdateSpeakerInfo, initialSpeakerInfo } from '../../Services/allApi';

function AddNewSpeaker({ setisSpeakerImageForm }) {
    const [memberData, setMemberData] = useState({
        speaker_name: null,
        speaker_image: null,
        salutation: null,
        mal_salutation: null,
        mal_speaker_name: null,
        id: null
    });
    const [InitailImage, setInitailImage] = useState()
    const [imagePreview, setImagePreview] = useState('');
    const baseUrl = process.env.REACT_APP_BASEURL
    // upload images
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setMemberData({ ...memberData, speaker_image: file });
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    // API call for images submit
    const handleSave = async () => {
        const formData = new FormData();
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Authorization": `${token}`
        };
        // Append member data to formData
        formData.append('speaker_name', memberData.speaker_name);
        formData.append('salutation', memberData.salutation);
        formData.append('mal_salutation', memberData.mal_salutation);
        formData.append('mal_speaker_name', memberData.mal_speaker_name);
        if (memberData?.id) {
            formData.append('id', memberData.id);
        }
        // Append image file if it exists
        formData.append('speaker_image', memberData.speaker_image);
        console.log(memberData);
        try {
            const result = await UpdateSpeakerInfo(formData, reqHeader);
            console.log(result);
            if (result?.data?.code === 201 || result?.data?.code === 200 || result?.code == 200) {
                toast.success("Speaker Details Updated")
                setTimeout(() => {
                    setisSpeakerImageForm(false)
                }, 2000)
            }
            else {
                toast.error(result?.response?.data?.message ?? 'There was an error updating speaker info')
            }
        } catch (error) {
            console.error('Error adding member:', error);
            const errorMessage = 'An unexpected error occurred';
            toast.error('An unexpected error occurred')
            // Handle error, display error message, etc.
        }
    };
    useEffect(() => {
        InitailMemberDetails()
    }, [])
    // get speaker details initially
    const InitailMemberDetails = async () => {
        const result = await initialSpeakerInfo()
        console.log(result);
        const name = result?.data?.data[0]?.speaker_name
        const salut = result?.data?.data[0]?.salutation
        const iniImg = result?.data?.data[0]?.speaker_image
        const sid = result?.data?.data[0]?.id ?? ''
        const mal_salut = result?.data?.data[0]?.mal_salutation
        const mal_speaker = result?.data?.data[0]?.mal_speaker_name

        setInitailImage(iniImg)
        setMemberData(prevData => ({
            ...prevData,
            speaker_name: name, salutation: salut, mal_salutation: mal_salut, mal_speaker_name: mal_speaker, speaker_image: iniImg, id: sid
        }));
    }
    return (<>
        <div className='w-full flex items-center flex-col justify-center shadow-lg bg-gray-100 border border-blue-400 rounded'>
            <h3 className='text-blue-700 text-xl font-bold mt-5 mb-5 text-center'>Enter Speaker Details</h3>
            <div className="flex flex-row gap-2 w-full justify-evenly items-center">
                <div className='w-2/12 items-center flex-col flex justify-center '>
                    <label htmlFor="memberimage" className='w-full h-48 cursor-pointer'>
                        <div className='bg-success border-dashed border-2 mb-10 h-full overflow-hidden p-2 rounded border-light-blue-600 flex justify-center items-center flex-col'>
                            {imagePreview ? (
                                <img className='h-full w-full' src={imagePreview} alt="Uploaded Preview" />
                            ) : (
                                <>
                                    <img className='h-7/12 w-7/12'
                                        //  src="https://cdn2.iconfinder.com/data/icons/dottie-user-part-1/24/user_003-upload-profile-account-people-arrow-512.png"
                                        src={`${baseUrl}${InitailImage}`}
                                        alt="Upload Icon" />
                                    <span className='text-blue-500 underline'>Upload image</span>
                                </>
                            )}
                        </div>
                    </label>
                    <input id='memberimage' type="file" style={{ visibility: 'hidden' }} onChange={handleImageUpload} />
                </div>
                <div className='flex flex-col gap-2 w-7/12 '>
                    <div className='flex flex-row justify-start flex-wrap mb-10 ms-5 me-5 gap-5 w-full'>
                        <div className='w-4/12 flex flex-col'>
                            <label htmlFor="membername">Display Name</label>
                            <input
                                id='membername'
                                value={memberData.speaker_name}
                                onChange={(e) => setMemberData({ ...memberData, speaker_name: e.target.value })}
                                type="text"
                                className='w-full h-10 rounded-lg border border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-4/12 flex flex-col'>
                            <label htmlFor="salutation">Salutation</label>
                            <input
                                id='salutation'
                                value={memberData.salutation}
                                onChange={(e) => setMemberData({ ...memberData, salutation: e.target.value })}
                                type="text"
                                className='w-full h-10 rounded-lg border border-gray-700 px-2'
                            />
                        </div>
                    </div>
                    {/* malayalam text fileds */}
                    <div className='flex flex-row justify-start flex-wrap mb-10 ms-5 me-5 gap-5 w-full'>
                        <div className='w-4/12 flex flex-col'>
                            <label htmlFor="membernamem">Display Name malayalam</label>
                            <input
                                id='membernamem'
                                value={memberData.mal_speaker_name}
                                onChange={(e) => setMemberData({ ...memberData, mal_speaker_name: e.target.value })}
                                type="text"
                                className='w-full h-10 rounded-lg border border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-4/12 flex flex-col'>
                            <label htmlFor="salutationm">Salutation malayalam</label>
                            <input
                                id='salutationm'
                                value={memberData.mal_salutation}
                                onChange={(e) => setMemberData({ ...memberData, mal_salutation: e.target.value })}
                                type="text"
                                className='w-full h-10 rounded-lg border border-gray-700 px-2'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className='w-2/12'>
                <button className='w-full py-2 bg-primary text-white rounded-lg mb-6' onClick={handleSave}>Save</button>
            </div>
        </div>
        <ToastContainer
            position="top-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            // pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
    </>
    );
}

export default AddNewSpeaker;
